<!-- Visible only while the dynamically-imported SciChart chunk is on the wire.
     The chart containers below stay mounted throughout: SciChartSurface.create()
     resolves them by id and cannot wait for *ngIf. -->
<!-- ONE LOADING STATEMENT AT A TIME.
     Two indicators answer two different questions: the full-screen overlay in
     main-layout means DATA is in flight, this one means the SciChart chunk is
     still on the wire. Both were rendered together on a first visit, which is
     where "we have a loading spinning wheel and scicharts has a native loading
     chart data" came from — two spinners, no indication they meant different
     things. The overlay is the outer, blocking state, so it wins; this appears
     only once data has settled and the chunk alone is outstanding. -->
<div
  class="chart-loading"
  *ngIf="!chartsReady && !(projectService.inFlightTelemetry | async)"
>
  {{ 'CuringLoadingCharts' | t }}
</div>
<div class="main-wrapper">
  <!-- RETURN TO LIVE.
       Shown ONLY while the user is behind, which is the whole point: a control that
       is always there says nothing about whether you are following. Rob's original
       report was that the slider "will not return you to the latest tick" — web held
       position correctly and simply offered no way forward again.

       The label reuses the EXISTING GridStatusLive key rather than a new one. A key
       missing from a runtime .lang renders as its own name, and these files are
       fetched, so a new key is a real risk of "LiveJumpToLatest" appearing on stage.
       GridStatusLive is present and properly translated in all six languages.

       "New data arrived" is signalled by the dot, not by a second string, for the
       same reason — it needs no key at all. -->
  <button
    type="button"
    class="return-to-live"
    [class.has-new]="newDataBehind"
    *ngIf="!followingLive"
    (click)="returnToLive()"
  >
    <span class="live-dot"></span>{{ 'GridStatusLive' | t }}
  </button>
  <div class="all-charts-container">
    <!-- <div class="liner"></div> -->
    <div class="sewer-container">
      <div class="sewer-left">
        <img src="../../assets/sewer.svg" />
      </div>
      <div class="sewer-graph">
        <div [id]="zoneGraph2Id" class="zone-graph-2"></div>
      </div>
      <div class="sewer-right">
        <img src="../../assets/sewer.svg" />
      </div>
    </div>
    <!-- <div class="zone-graph-2-container"></div> -->
    <div class="zone-graph-1-container">
      <div [id]="zoneGraph1Id" class="zone-graph-1"></div>
      <!-- Zones are derived in the browser and REFUSE rather than approximate.
           When they refuse, the strip says so and why; a dark strip would read
           as "all cool". -->
      <div class="zone-unavailable" *ngIf="zoneUnavailableText">{{ zoneUnavailableText }}</div>
    </div>
    <div class="offline-hatch-wrap">
      <div [id]="tempGraphId" class="temp-graph"></div>
      <!-- Says WHY the chart is blank. A pane that just stays empty reads as a
           still-loading chart, and an operator waits on it. -->
      <div class="chart-empty-state" *ngIf="geometryMissing">
        <p class="chart-empty-title">{{ 'TemperatureNoGeometryTitle' | t }}</p>
        <p class="chart-empty-detail">{{ 'TemperatureNoGeometryDetail' | t }}</p>
      </div>
      <app-offline-hatch></app-offline-hatch>
    </div>
    <div class="rng_slider_container">
      <div class="rng_sliders_control" *ngIf="showRangeSlider">
        <input
          id="fromSlider"
          type="range"
          value="0"
          min="0"
          max="100"
          #fromSlider
          (input)="updateChartVisibleRange(fromSlider.value, toSlider.value)"
        />
        <input
          id="toSlider"
          type="range"
          value="100"
          min="0"
          max="100"
          #toSlider
          (input)="updateChartVisibleRange(fromSlider.value, toSlider.value)"
        />
      </div>
    </div>
  </div>
  <div class="chart-controls">
    <div class="controls-top">
      <div class="help-btn" (click)="toggleHelpOverlay()">
        <img src="../../assets/Help/Help.svg" alt="" class="help-btn-img" />
      </div>
      <ul>
        <li
          (click)="setRollOver(true)"
          [class]="[rolloverModifier?.isEnabled ? 'highlighted' : '']"
        >
          <a [routerLink]="" class="link1"></a>
          <img
            src="../../assets/Help/Inspect.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li
          (click)="setPan(true)"
          [class]="[zoomPanModifier?.isEnabled ? 'highlighted' : '']"
        >
          <a [routerLink]="" class="link2"></a>
          <img
            src="../../assets/Help/Drag.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li
          (click)="setZoom(true)"
          [class]="[rubberBandZoomModifier?.isEnabled ? 'highlighted' : '']"
        >
          <a [routerLink]="" class="link3"></a>
          <img
            src="../../assets/Help/Zoom.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
      </ul>
    </div>
    <div class="controls-top">
      <ul>
        <li (click)="zoomOut()">
          <a [routerLink]="" class="link4"></a>
          <img
            src="../../assets/Help/Zoom out.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li (click)="toggleRangeSlider()">
          <a [routerLink]="" class="link5"></a>
          <img
            src="../../assets/Help/Show Hide Zoom Control.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
      </ul>
    </div>
    <div class="controls-spacer"></div>
    <div class="controls-bottom">
      <ul>
        <li (click)="addMarker()">
          <a [routerLink]="" class="link6"></a>
          <img
            src="../../assets/Help/Add Marker .svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li>
            <!-- Camera. Captures ONE named surface and the tooltip says which,
                 because a screen-level control bar cannot sit beside its chart
                 the way the desktop's per-chart camera does. -->
            <a
              [routerLink]=""
              class="link7"
              [appChartScreenshot]="'temperature'"
              chartLabel="Temperature"
              [projectName]="projectService.selectedProjectName"></a>
          </li>
      </ul>
    </div>
  </div>
</div>
